import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Aiosell**
 *
 * @exports bs_411
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_411
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.querySelector('app-root');
        if (container) {
            const aiosellPageRefresh = thn.debounce(() => {
                thn.pageCheck();
            }, 600);
            thn.observeDom(container, aiosellPageRefresh, {
                childList: true,
                attributes: true,
            });
            thn.shutdown(() => {
                aiosellPageRefresh.cancel();
                thn.stopObserveDom(container, aiosellPageRefresh);
            });
        }
        const pageChange = thn.delegate('click', 'app-room-card .more-rates button', () => {
            thn.pageCheck();
        });
        thn.shutdown(() => {
            pageChange();
        });
    };
    /**
       * @memberOf module:bs_411
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
       * @memberOf module:bs_411
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 300);
    };
    /**
       * @memberOf module:bs_411
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.room-cards');
        if (container) {
            let refreshPrice = thn.debounce(() => ctx.widget.refresh(), 400);
            thn.observeDom(container, refreshPrice, {
                childList: true,
                subtree: false,
                attributes: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(container, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
      *
      * @memberOf module:bs_411
      *
      */
    function roomDetailsParseData(adult, childs) {
        const roomElArray = [...document.querySelectorAll('app-room-card')];
        if (thn.empty(roomElArray)) {
            return {};
        }
        const roomsInfo = roomElArray
            .map((room) => {
            const roomName = room.querySelector('.room-info .h4')?.textContent;
            const roomType = getRoomType(roomName);
            const adults = adult;
            const child = childs;
            const roomRates = [...room.querySelectorAll('.more-rates')]
                .map((rate) => {
                const rateName = rate.querySelector('.align-items-center')?.textContent;
                const price = thn.parseNumber(rate.querySelector('span:not(.rate)')?.textContent);
                const hasBreakfast = false;
                const isRefundable = false;
                const infoRate = {
                    id: '',
                    name: rateName,
                    totalNight: price,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return infoRate;
            });
            return {
                id: '',
                name: roomName,
                adults: adults,
                children: child,
                type: roomType,
                prices: roomRates,
            };
        }).filter(Boolean);
        return roomsInfo;
    }
    /**
       * @memberOf module:bs_411
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        let nights;
        // Dates
        const dateBegin = document.querySelector('#mat-input-0')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        const dateEnd = document.querySelector('#mat-input-1')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        const adults = thn.parseNumber(document.querySelector('#mat-select-value-1 > span > span')?.textContent) || 1;
        const children = 0;
        widgetData.adults = adults;
        widgetData.children = children;
        widgetData.roomsDispo = [];
        const rooms = thn.parseNumber(document.querySelector('#mat-select-value-3 span span')?.textContent) || 1;
        for (let i = 0; i < rooms; i += 1) {
            const roomInfo = {
                adults: widgetData.adults,
                children: 0,
                childrenAges: [],
            };
            widgetData.roomsDispo.push(roomInfo);
        }
        // Prices & Currency || No Rooms
        const noAvailability = thn.empty([...document.querySelectorAll('app-room-card')].filter((room) => !room.querySelector('.sold-out')));
        const prices = [...document.querySelectorAll('.room-info .price-sec span:not(.rate)')].map((el) => thn.parseNumber(el?.textContent)).filter(Boolean);
        const currency = thn.parseCurrency(document.querySelector('.rate')?.textContent);
        if (thn.notEmpty(prices)) {
            widgetData.price = Math.min(...prices) / nights;
            widgetData.currency = currency;
            widgetData.rooms = rooms;
            widgetData.roomDetails = roomDetailsParseData(widgetData.adults, widgetData.children);
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_411
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingId = document.querySelector('h3:nth-child(2)')?.textContent || window.location.pathname.split('vouchers/')[1];
        const dateBegin = document.querySelector('body > center > table:nth-child(1) > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(3) > td:nth-child(2)')?.innerText;
        const dateEnd = document.querySelector('body > center > table:nth-child(1) > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(4) > td:nth-child(2)')?.innerText;
        widgetData.bookingId = bookingId;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = translateDate(dateBegin, thn.data.language || 'en');
            widgetData.dateEnd = translateDate(dateEnd, thn.data.language || 'en');
        }
        const priceText = document.querySelector('body > center > table:nth-child(1) > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(21) > td:nth-child(2)')?.innerText;
        const totalPrice = thn.parseNumber(priceText);
        const currency = thn.parseCurrency(priceText);
        widgetData.price = totalPrice;
        widgetData.currency = currency;
        return widgetData;
    };
    return engine;
}

export { factory };
